export default __webpack_public_path__ + "static/media/icon-status.e48239b1.svg";